import { ITypedReduxAction, TThunkAction } from '../../types/redux';

export enum EAuthenticationActionType {
  Succeed = 'authentication/succeed',
  Cancelled = 'authentication/cancelled',
}

export type TAuthenticationSucceed = ITypedReduxAction<EAuthenticationActionType.Succeed>;
export type TAuthenticationCancelled = ITypedReduxAction<EAuthenticationActionType.Cancelled>;

export type TAuthenticationActions = TAuthenticationSucceed | TAuthenticationCancelled;

interface IViewData {
  headingType: string;
}

export interface IRequestAuthenticationParameters {
  viewData?: IViewData;
  source?: string;
  onSuccess?(): TThunkAction;
  onCloseNoAuth?(): TThunkAction;
}
